import { useDispatch } from 'react-redux';
import NsContent from 'components/common/ns-content/NsContent';

import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { AddressCard } from 'components/direct-sales/meterpoint-validation/components/AddressCard';
import { MeterpointCard } from 'components/direct-sales/meterpoint-validation/components/MeterpointCard';
import { MeterpointGuideCta } from 'components/direct-sales/meterpoint-validation/components/MeterpointGuideCta';

import {
  setMPAN,
  setMPRN
} from 'state/meterpoint-validation/meterpoint-validation-slice';
import { getMeterpointDetails } from 'state/meterpoint-validation/meterpoint-validation-thunks';
import { useMeterpointValidation } from 'components/direct-sales/meterpoint-validation/hooks/useMeterpointValidation';
import { Error } from 'components/common/error/Error';
import { NsForm } from 'components/common/ns-form/NsForm';
import { NsMpanInput } from 'components/common/ns-mpan-input/NsMpanInput';
import { NsMprnInput } from 'components/common/ns-mprn-input/NsMprnInput';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';
import { useNavigation } from 'hooks/useNavigation';

export const testId = 'MeterpointValidationTestId';
export const variantTestId = 'MeterpointValidationVariantTestId';

export const MeterpointValidation = () => {
  const dispatch = useDispatch();

  const { eventTypes, next } = useNavigation();

  const {
    addresses,
    electricityValidation,
    gasValidation,
    errors,
    isLoading,
    MPAN,
    MPRN,
    hasMissingAddress,
    hasElecAddress,
    hasGasAddress
  } = useMeterpointValidation();

  const handleSubmit = async () => {
    if (!hasMissingAddress) {
      next({ eventType: eventTypes.NEXT });
    } else {
      try {
        await dispatch(
          getMeterpointDetails({
            ...(MPAN && { mpan: MPAN }),
            ...(MPRN && { mprn: MPRN })
          })
        );
      } catch (e) {
        e && console.error(e);
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    name === 'MPRN' && dispatch(setMPRN(value));
    name === 'MPAN' && dispatch(setMPAN(value));
  };

  if (isLoading) {
    return <NsStopgap />;
  }

  return (
    <NsPanel testId={testId}>
      <NsBackCta />
      <NsContent>
        <NsTitle title="Let’s find your meter details" />
        <p>
          Please enter your meter reference number. We need this to locate your
          property and give you an accurate quote. You’ll find it on an old
          energy bill. It’s different from meter readings and meter serial
          number. Need help? <MeterpointGuideCta />
        </p>
      </NsContent>
      <Error errors={errors} />
      <AddressCard
        addresses={addresses}
        electricity={electricityValidation}
        gas={gasValidation}
      />
      <MeterpointCard
        MPAN={MPAN}
        MPRN={MPRN}
        hasElecAddress={hasElecAddress}
        hasGasAddress={hasGasAddress}
      />
      <NsForm onSubmit={handleSubmit}>
        {electricityValidation && !hasElecAddress && (
          <NsMpanInput
            name="MPAN"
            value={MPAN}
            label="MPAN for electricity"
            onChange={handleChange}
          />
        )}
        {gasValidation && !hasGasAddress && (
          <NsMprnInput
            name="MPRN"
            value={MPRN}
            label="MPRN for gas"
            onChange={handleChange}
          />
        )}

        <NsPrimaryCta isLoading={isLoading}>
          {!hasMissingAddress ? 'Confirm details' : 'Submit'}
        </NsPrimaryCta>
      </NsForm>
    </NsPanel>
  );
};

export default MeterpointValidation;
